<nav class="nav">
  @for (item of rendering?.fields?.items; track item) {
    <a *wlGenericLink="item?.fields?.link" class="nav-link p-0">
      {{ item?.fields?.name.value }}
    </a>
  }
</nav>
